'use client'

const ContactUsBanner = () => {
    return (
        <div className='h-48 relative w-full md:rounded-2xl bg-gradient-to-br from-primary via-red-500 to-orange-400 flex flex-col items-center justify-center gap-4 overflow-hidden'>
            <p className='py-1 px-3 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium border border-white/30 uppercase'>write to us</p>
            <p className='text-4xl sm:text-5xl font-semibold lg:text-5xl text-white'>Contact us</p>
        </div>
    );
}

export default ContactUsBanner;